import React, { PropsWithChildren } from "react";
import { AppearanceTypes, ToastProps } from "react-toast-notifications";
import { colors } from "../../stitches.config";
import { Container, IconWrapper, LeftContent } from "./__styles__/Toast";
import { ActionButton } from "./Buttons/ActionButton";
import { Icon, IconNames } from "./Icons/LucideIcons";
import { Body } from "./Typography";
const IconMap: Record<AppearanceTypes, IconNames> = {
  success: "check-circle",
  error: "x-circle",
  info: "info",
  warning: "alert-circle",
};

const ColorMap: Record<AppearanceTypes, keyof typeof colors> = {
  success: "contentSuccessInverted",
  error: "contentCriticalInverted",
  warning: "contentAttentionInverted",
  info: "contentInfoInverted",
};

export default ({
  children,
  appearance = "info",
  transitionDuration,
  onDismiss,
  transitionState,
}: PropsWithChildren<ToastProps> & { appearance?: AppearanceTypes }) => {
  return (
    <Container
      transitionState={transitionState}
      style={{ transitionDuration: `${transitionDuration}ms` }}
    >
      <LeftContent>
        <IconWrapper>
          <Icon
            iconName={IconMap[appearance] as IconNames}
            color={ColorMap[appearance] as keyof typeof colors}
            size={16}
          />
        </IconWrapper>
        <Body color="contentPrimaryInverted" size={"default"} type={"emphasis"}>
          {children}
        </Body>
      </LeftContent>
      <IconWrapper>
        <ActionButton
          icon="x"
          onClick={() => onDismiss()}
          aria-label="Dismiss"
          data-testid="dismiss-toast"
          variant="inverted"
        />
      </IconWrapper>
    </Container>
  );
};
